export var createAxiosHttpAdapter = function (httpClient) {
    var http = {
        get: function (url, headers) { return httpClient.get(url, { headers: headers }).then(function (req) { return req.data; }); },
        // tslint:disable-next-line:max-line-length
        post: function (url, body, headers, onUploadProgress) { return httpClient.post(url, body, {
            onUploadProgress: onUploadProgress, headers: headers
        }).then(function (req) { return req.data; }); },
        put: function (url, body, headers) { return httpClient.put(url, body, { headers: headers }).then(function (req) { return req.data; }); },
        delete: function (url, headers) { return httpClient.delete(url, { headers: headers }).then(function (req) { return req.data; }); }
    };
    return http;
};
//# sourceMappingURL=base-http-client-adapter.js.map